import React from "react";

import styles from "./style.module.scss";



interface ISectionHeaderProps {
  title: string;
  info?: string;
  titleStyle?: React.CSSProperties;
  children?: React.ReactNode;
  className?: string
}
const SectionHeader = ({
  title,
  info,
  titleStyle,
  children,
  className
}: ISectionHeaderProps) => {
  return (
    <div className={`text-center ${className}`}>
      {info && <p className="m-0 mb-1 primary">{info}</p>}
      <div className={styles["title-wrapper"]}>
        {/* <img src={rightGrain} alt="rice left" className={styles["rice-icon"]} /> */}
        <h2 style={titleStyle} className={styles["title"]}>
          {title}
        </h2>
        {/* <img src={leftGrain} alt="rice right" className={styles["rice-icon"]} /> */}
      </div>
      {children}
    </div>
  );
};

export default SectionHeader;
